import React from 'react';
import styles from './ListedSharedToggle.module.css';

type Props = {
  isShared: boolean;
  disabled?: boolean;
  onToggle: (e: React.MouseEvent) => void;
};

/** Listed-tab Shared column: green = shared on VL, red = unshared (no QA status change). */
export function ListedSharedToggle({ isShared, disabled = false, onToggle }: Props) {
  return (
    <button
      type="button"
      className={[styles.sharedToggle, isShared ? styles.sharedOn : styles.sharedOff].filter(Boolean).join(' ')}
      disabled={disabled}
      aria-pressed={isShared}
      aria-label={isShared ? 'Shared — click to unshare from all marketplaces' : 'Unshared — click to share on selected marketplaces'}
      title={
        isShared
          ? 'Shared on marketplaces — click to unshare from all marketplaces'
          : 'Not shared — click to share on selected marketplaces'
      }
      onClick={onToggle}
    >
      <span className={styles.sharedToggleDot} aria-hidden="true" />
    </button>
  );
}
